export default __webpack_public_path__ + "static/media/geriatrics.d78224ce.png";